import { FC, PropsWithChildren, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { GallerySlide } from '../gallery-slide';
import { ClickPosition } from '~/utils/click-position';
import { useScopedAtomValue, useSetScopedAtom } from '@lemon8/web-app-shared/ssr';
import { $CurrentGalleryArticle, $CurrentGallerySlide, $GallerySwiper } from '../../atoms';
import { $CurrentPositionPrefix } from '~/models/current-position-prefix';
import { $AdditionalParams } from '~/models/additional-params';

import './style.scss';

export const GallerySection: FC<PropsWithChildren> = ({ children }) => {
  const article = useScopedAtomValue($CurrentGalleryArticle);
  const setGallerySwiper = useSetScopedAtom($GallerySwiper);
  const currentGallerySlide = useScopedAtomValue($CurrentGallerySlide);
  const prefix = useScopedAtomValue($CurrentPositionPrefix);
  const additionalParams = useScopedAtomValue($AdditionalParams);

  const { imageList, ocrText = [], imageAutoGenDesp = [] } = article;

  const imageListWithExtraInfo = imageList.map((image, index) => {
    return {
      ...image,
      imgOcrText: ocrText[index] || '',
      imgAutoGenDesc: imageAutoGenDesp[index] || '',
    };
  });

  /**
   * open gallery slide modal only once
   */
  const galleryInit = useRef(false);
  useEffect(() => {
    if (!galleryInit.current && !currentGallerySlide) {
      return;
    }
    galleryInit.current = true;

    window.Tea('wap_click', {
      current_position: prefix + ClickPosition.main_gallery_slide,
      ...additionalParams,
    });
  }, [currentGallerySlide]);

  return (
    <SwiperSlide className="gallery-slide-gallery">
      <Swiper onSwiper={setGallerySwiper} className="gallery-gallery-swiper" resistanceRatio={0} nested>
        {imageListWithExtraInfo.map((image, index) => (
          <GallerySlide key={index} image={image} index={index} imgCount={imageListWithExtraInfo.length} />
        ))}
      </Swiper>
      {children}
    </SwiperSlide>
  );
};

GallerySection.displayName = SwiperSlide.displayName;
